// extracted by mini-css-extract-plugin
module.exports = {"sharePopover":"ae","shareText":"af","show":"ag"};